import { Translate } from '@change-corgi/core/react/i18n';
import { Text } from '@change-corgi/design-system-legacy/typography';

export function FilledTemplateNotice() {
	return (
		<div
			data-qa="update-supporters-filled-template-notice"
			sx={{
				backgroundColor: 'primary-greyBackground',
				borderRadius: 8,
				margin: '32px 0',
				padding: 16,
				display: 'flex',
				gap: 4,
				flexDirection: 'column',
				lineHeight: 20,
			}}
		>
			<Text as="p" fontWeight="bold">
				<Translate value="corgi.petition_update.pre_filled_form_notice.header" />
			</Text>
			<Text as="p">
				<Translate value="corgi.petition_update.pre_filled_form_notice.description" />
			</Text>
		</div>
	);
}
